import { render } from "./SideBarComp.vue?vue&type=template&id=4b1a822c&scoped=true"
import script from "./SideBarComp.vue?vue&type=script&lang=js"
export * from "./SideBarComp.vue?vue&type=script&lang=js"

import "./SideBarComp.vue?vue&type=style&index=0&id=4b1a822c&scoped=true&lang=css"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1a822c"]])

export default __exports__